module.exports = __webpack_public_path__ + "img/Morbida_island.ad411a74.png";